"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var Styles = __importStar(require("./Acordeao.styles"));
var react_feather_1 = require("react-feather");
var Conteudo_1 = __importDefault(require("./Conteudo"));
var tema_1 = require("../../tema");
var framer_motion_1 = require("framer-motion");
function Acordeao(_a) {
  var items = _a.items,
    indiceInicialExpandido = _a.indiceInicialExpandido,
    propsDoRotulo = _a.propsDoRotulo,
    propsDoConteudo = _a.propsDoConteudo,
    propsDoContainer = _a.propsDoContainer,
    icones = _a.icones;
  var _b = react_1.useState(indiceInicialExpandido),
    expandido = _b[0],
    setExpandido = _b[1];
  var recolherOuExpandir = function (indice) {
    if (indice === expandido) {
      setExpandido(undefined);
    } else {
      setExpandido(indice);
    }
  };
  var iconeVisivel = !!(icones === null || icones === void 0 ? void 0 : icones.visivel) ? icones.visivel : react_1.default.createElement(react_feather_1.ChevronUp, null);
  var iconeNaoVisivel = !!(icones === null || icones === void 0 ? void 0 : icones.naoVisivel) ? icones.naoVisivel : react_1.default.createElement(react_feather_1.ChevronDown, null);
  return react_1.default.createElement(tema_1.Tema, null, items.map(function (item, indice) {
    return react_1.default.createElement(Styles.Wrapper, __assign({
      key: indice
    }, propsDoContainer), react_1.default.createElement(Styles.Header, {
      onClick: function () {
        return recolherOuExpandir(indice);
      }
    }, react_1.default.createElement(Styles.Label, __assign({}, propsDoRotulo), item.rotulo), react_1.default.createElement(Styles.IconWrapper, null, expandido === indice ? iconeVisivel : iconeNaoVisivel)), react_1.default.createElement(framer_motion_1.AnimatePresence, null, expandido === indice && react_1.default.createElement(Conteudo_1.default, __assign({
      conteudo: item.conteudo
    }, propsDoConteudo))));
  }));
}
exports.default = Acordeao;